module.exports = "<svg viewBox=\"0 0 15 12\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.92 11.84C9.2 11.84 15 5.92 15 5.92S9.2 0 5.92 0C2.65 0 0 2.65 0 5.92s2.65 5.92 5.92 5.92z\" fill=\"#0075FF\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/svg/marker.svg
// module id = MSQN
// module chunks = 89